import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Table from '../../../common/components/table/simple-table';

const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
		display:'inline-block',
		color:"#FFFFFF"

	},
	closeIcon:{
		position:'absolute',
		top:10,
		right:10
	},
});

const columns = [
	{name:'FileName',title:'ファイル名'},
	{name:'DataTeikyoumotoCD',title:'データ提供元コード'},
	{name:'MakerCD',title:'メーカーコード'},
	{name:'ButsuryuBotenCD',title:'物流母店コード'},
	{name:'NouhinJigyoushaCD',title:'納品事業者コード'},
	{name:'KanriNO1',title:'管理番号1'},
	{name:'KanriNO2',title:'管理番号2'},
	{name:'KanriNO3',title:'管理番号3'},
	{name:'ShukkaYoteiYMD',title:'出荷予定日'},
	{name:'NohinYoteiYMD',title:'納品予定日'},
	{name:'HacchuYMD',title:'発注日'},
	{name:'HacchuNO',title:'発注番号'},
	{name:'DenpyoYMD',title:'伝票日付'},
	{name:'DenpyoNO',title:'伝票番号'},
	{name:'NinushiTorihikiCD',title:'荷主取引コード'},
	{name:'NinushiTorihikiName',title:'荷主取引名称'},
	{name:'TeiseiKbn',title:'訂正区分'},
	{name:'NinushiName',title:'荷主名称'},
	{name:'NinushiZipCD',title:'荷主郵便番号'},
	{name:'NinushiAddress',title:'荷主住所'},
	{name:'NinushiTel',title:'荷主TEL'},
	{name:'NinushiChikuCD',title:'荷主地区コード'},
	{name:'ToiawasesakiName',title:'問合せ先名称'},
	{name:'ToiawasesakiZipCD',title:'問合せ先郵便番号'},
	{name:'ToiawasesakiAddress',title:'問合せ先住所'},
	{name:'ToiawasesakiTel',title:'問合せ先TEL'},
	{name:'ToiawasesakiChikuCD',title:'問合せ先地区コード'},
	{name:'NohinsakiCD',title:'納品先コード'},
	{name:'OtodokesakiName',title:'お届先名称'},
	{name:'OtodokesakiZipCD',title:'お届先郵便番号'},
	{name:'OtodokesakiAddress',title:'お届先住所'},
	{name:'OtodokesakiTel',title:'お届先TEL'},
	{name:'OtodokesakiChikuCD',title:'お届先地区コード'},
	{name:'ChoaisakiCD1',title:'帳合先コード1'},
	{name:'ChoaisakiName1',title:'帳合先名称1'},
	{name:'ChoaisakiCD2',title:'帳合先コード2'},
	{name:'ChoaisakiName2',title:'帳合先名称2'},
	{name:'UnsouKaishaCD',title:'運送会社コード'},
	{name:'UnsoukaishaName',title:'運送会社名称'},
	{name:'DenpyoGokeiKokuchiNum',title:'伝票合計個口数'},
	{name:'DenpyoGokeiJuryo',title:'伝票合計重量（kg）'},
	{name:'DenpyoGokeiJuchuNum',title:'伝票合計受注数量'},
	{name:'DenpyoGokeiBaraNum',title:'伝票合計バラ数'},
	{name:'NohinGokeiKokuchiNum',title:'納品合計個口数'},
	{name:'NohinGokeiJuryo',title:'納品合計重量[kg]'},
	{name:'JikanshiteiFrom',title:'時間指定FROM'},
	{name:'JikanshiteiTo',title:'時間指定TO'},
	{name:'DenpyoBikou1',title:'伝票備考1'},
	{name:'DenpyoBikou2',title:'伝票備考2'},
	{name:'DenpyoBikou3',title:'伝票備考3'},
	{name:'DenpyoBikou4',title:'伝票備考4'},
	{name:'DenpyoBikou5',title:'伝票備考5'},
	{name:'Koyuran1',title:'固有欄１'},
	{name:'Koyuran2',title:'固有欄２'},
	{name:'Koyuran3',title:'固有欄３'},
	{name:'Koyuran4',title:'固有欄４'},
	{name:'HacchuGyoNO',title:'発注行番号'},
	{name:'DenpyoGyoNO',title:'伝票行番号'},
	{name:'DenpyoGyoEdaNO',title:'伝票行番号（枝番）'},
	{name:'ShohinCD',title:'商品コード'},
	{name:'ShohinOroshiPrivateCD',title:'商品コード（卸プライベートコード）'},
	{name:'JANKbn',title:'JAN区分'},
	{name:'JANCD',title:'JANコード'},
	{name:'ShohinKigou1',title:'商品記号１'},
	{name:'ShohinKigou2',title:'商品記号２'},
	{name:'ShohinName',title:'商品名'},
	{name:'Kikaku',title:'規格・容量'},
	{name:'SeizouNO',title:'製造番号'},
	{name:'ShiyouKigen',title:'使用期限'},
	{name:'LotHyojiFlag',title:'ロット表示フラグ'},
	{name:'LotKichouGimuFlag',title:'ロット記帳義務フラグ'},
	{name:'CaseIrisu',title:'ケース入数'},
	{name:'JuchuSuryo',title:'受注数量'},
	{name:'Suryo',title:'数量'},
	{name:'SouBaraSuryo',title:'総バラ数量'},
	{name:'LotSuryo',title:'ロット数量'},
	{name:'LotSouBaraSuryo',title:'ロット総バラ数量'},
	{name:'Konsu',title:'梱数'},
	{name:'Hasu',title:'端数'},
	{name:'NisugataTani',title:'荷姿単位'},
	{name:'MeisaiBikou',title:'明細備考'},
	{name:'CaseJuryo',title:'ケース重量（kg）/1ケース'},
	{name:'UnchinJuryo',title:'運賃重量（kg）/1ケース'},
	{name:'CaseSaisu',title:'ケース才数'},
	{name:'CaseYouseki',title:'ケース容積[cm3]'},
	{name:'Yobi1',title:'予備項目１'},
	{name:'Yobi2',title:'予備項目２'},
	{name:'Yobi3',title:'予備項目３'},
	{name:'Yobi4',title:'予備項目４'},
	{name:'Yobi5',title:'予備項目５'},
	{name:'MeisaiYobi1',title:'明細予備項目１'},
	{name:'MeisaiYobi2',title:'明細予備項目２'},
	{name:'MeisaiYobi3',title:'明細予備項目３'},
	{name:'MeisaiYobi4',title:'明細予備項目４'},
	{name:'MeisaiYobi5',title:'明細予備項目５'},
	{name:'MeisaiYobi6',title:'明細予備項目６'},
	{name:'CarNumber',title:'車番'},
	{name:'RotationNO',title:'回転'},
	{name:'HaisoNO',title:'配送順'},
];

const columns2 = [
	{name:'FileName',title:'ファイル名'},
	{name:'MakerCD',title:'メーカーコード'},
	{name:'NohinYoteiYMD',title:'納品予定日'},
	{name:'DenpyoNO',title:'伝票番号'},
	{name:'CarNumber',title:'車番'},
	{name:'RotationNO',title:'回転'},
	{name:'HaisoNO',title:'配送順'},
	{name:'TodokedeJikan',title:'届出時間'},
	{name:'NokisakiJouken',title:'軒先条件'},
]

class complete extends React.Component {

	constructor(props) {
		super(props);
		this.state = {

		}
	}

	handleClose = () => {
		if(this.props.afterCloseFunc) this.props.afterCloseFunc();
	};

	render () {
		const { classes,dataSource,processDivide } = this.props;

		return (
			<div className="over_rays">
				<div className={classes.closeIcon}>
					<IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
								onClick={this.handleClose}>
						<CloseIcon/>
					</IconButton>
				</div>
				<div className="over_rays_title">取込完了</div>
				<Table
					dataSource={dataSource}
					columns={(processDivide === "1") ? columns : columns2}
					isGrouping={true}
					groupingColumns={'FileName'}
				/>
			</div>
		);
	}
}
complete.propTypes = {
	dataSource: PropTypes.array,
	afterCloseFunc:PropTypes.func,
	processDivide:PropTypes.string

};
complete.defaultProps = {
	dataSource: [],
	processDivide:"1"
};
export default withStyles(styles)(complete);



// WEBPACK FOOTER //
// ./src/routes/upload/components/complete.js